import { render, staticRenderFns } from "./Tujuan.vue?vue&type=template&id=4603df35&"
import script from "./Tujuan.vue?vue&type=script&lang=js&"
export * from "./Tujuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports